<template>
    <div class="__emails-container">	
      <div class="__navigators">
            <nav class=" breadcrumb3">
              <ol>
                  <li><a v-bind:href="h.routes.home" v-text="t.label_home"></a></li>
                  <!-- <li><a v-bind:href="h.routes.init" v-text="t.title_emails_app"></a></li> -->
                  <li><a v-bind:href="h.routes.init" v-text="t.label_initial"></a></li>
              </ol>
          </nav>
      </div>
      <div class="__wrapper">
          <div class="__domain-container">
              <ul class="__domain-list" v-if="domains != null && domains.length > 0">
                  <li v-for="d in domains" v-bind:class="d.selected && !d.processing ? '__domain-selected': '__domain'" @click="selectDoamin(d)" :data-ba-i="d.selected ? `show-domain-email-list` : `hide-domain-email-list`"><span style='margin-right:0.5em; display:inline-block;'>&nbsp;</span>{{ toUnicode(d.domain, false) }} 
                    <i v-if="d.selected == false" class="fa fa-angle-down"></i>
                    <img v-else-if="d.processing == true" class="__loader" src="/internacional/public/office4/img/dashboard/load.svg">
                    <i v-else-if="d.selected == true" class="fa fa-angle-left"></i>

                    <ul v-if="d.selected">
                      <li class="__email" v-for="e in d.emails"><span style='margin-right:1.0em; display:inline-block;'>&nbsp;</span> {{ toUnicode(e.email, true) }}</li>
                    </ul>
                  </li>
              </ul>
              <div v-else>
                  <h2 class="no_domain_info" v-text="t.label_no_domain"></h2>
              </div>
          </div>
          <div class="__email-actions">
                <button v-bind:class="(domain === null) ? 'btn button3 __btnCreate __btn-disabled' : 'btn button3 __btnCreate'" @click="openModalCreate()" data-ba-i="open-create-email-modal"><img :src="`/internacional/public/emails-app/email-icon.svg`">{{t.label_create_email}}</button>
                <a class="btn button3 __btnList" v-text="t.label_view_email_list" :href="h.routes.list_emails" data-ba-i="access-available-domain-list"></a>
                <h2 v-if="(domain === null)" class="__info" v-text="t.no_selected_domain"></h2>
                <h2 v-else class="__info">&nbsp;</h2>
          </div>
      </div>

      <!-- MESSAGE LIMIT EMAILS -->
      <div id="modalLimitEmails" class="modal inmodal fade" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close" data-ba-i="close-change-password-modal"><span aria-hidden="true">&times;</span></button>
                </div>
                <div class="modal-body">
                  <svg xmlns="http://www.w3.org/2000/svg" width="86" height="86" fill="#FFC001" class="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                    <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"/>
                    <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"/>
                  </svg>
                  <h4 v-text="t.limit_submit_emails"></h4>
                  <p v-text="t.limit_submit_emails_rules"></p>
                  <div class="box-dont-show-message-modal">
                    <input type="checkbox" id="dontshowmessagemodal" v-model="dontShowModal" @change="toggleStatusShowMessage()">
                    <label for="dontshowmessagemodal" v-html="t.label_checkbox_popup_news"></label>
                  </div>
                </div>
            </div>
        </div>
      </div>

      <!-- CREATE EMAIL COMPONENT -->
      <create-email v-show="showCreate" :domain="domain" :translations="t" :handlers="h" :show="showCreate" v-on:created="createdEmail()" v-on:hide="openModalCreate()" data-ba-i="open-create-email-modal"></create-email>
    
    </div>
</template>

<script type="text/javascript">
    import qs from "qs";
    import punycode from "punycode";
    export default {
    name: "emails-app",
    props: ["app"],
    data() {
        return {
        	h: this.app.handlers,
        	t: this.app.translations,
          domains: this.app.domains,
          domain:  null,
          showCreate: false,
          dontShowModal: false,
        };
    },
    methods: {
      createdEmail(){
        this.openModalCreate()
        this.listEmails(this.domain)
      },
      openModalCreate: function(){
        if(this.domain != null){

          if(this.showCreate){
            this.showCreate = false
          }else{
            this.showCreate = true
          }

        }
      },
      selectDoamin(d){
        if(this.domain == null || !this.domain.processing){
          if(d.selected){
            this.domain = null
            d.selected  = false
          }else{
            if(this.domain !== null){
              this.domain.selected = false
            }

            this.domain  = d
            this.domain.selected  = true
            this.listEmails(d)
          }
        }
      },
      listEmails(d){
        d.emails = null
        d.processing = true
        let vm = this
        axios
          .post(
              vm.h.routes.list,
              qs.stringify({domain: d.domain })
          )
          .then(function(response) {
              if(response.data.status){
                d.emails = response.data.data.list
              }
          })
          .catch(function(error) {
              
          })
          .finally(function(){
            d.processing = false
          });
      },
      toUnicode(text, isEmail){
        if(isEmail) {
          if(text.includes('@')){
            let parts = text.split('@')
            return punycode.toUnicode(parts[0]) + '@' + punycode.toUnicode(parts[1]) 
          }
        }
        return punycode.toUnicode(text)
      },
      toggleStatusShowMessage(){
        localStorage.setItem('dontShowEmailLimitMessage',this.dontShowModal);
        console.log(this.dontShowModal);
      },
      toASCII(text, isEmail){
        if(isEmail) {
          if(text.includes('@')){
            let parts = text.split('@')
            return punycode.toASCII(parts[0]) + '@' + punycode.toASCII(parts[1]) 
          }
        }
        return punycode.toASCII(text)
      },
  },
  mounted(){
    // true -> dont show message
    // false -> show message
    let stateModalEmailLimit = !localStorage.getItem('dontShowEmailLimitMessage') ? false : localStorage.getItem('dontShowEmailLimitMessage');
    this.dontShowModal = stateModalEmailLimit == 'false' || !stateModalEmailLimit ? false : true;
    if(!this.dontShowModal || this.dontShowModal == 'false')
    {
      $('#modalLimitEmails').modal('show');
    }
  }
};
</script>

<style scoped lang="scss">
.modal-header{
  border-top: 20px solid #FFC000;
  border-radius: 6px 6px 0 0;
  span{
    font-size: 1.4rem;
  }
}
.modal-content{
  border-radius: 10px !important;
}
.modal-body{
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  font-family: 'Lato';
  h4{
    font-weight: 900;
    font-size: 25px;
    color: #444444;
  }
  .box-dont-show-message-modal{
    display: flex;
    justify-content: center;
    align-content: center;
    gap: 1rem;
  }
  p{
    text-align: center;
    font-weight: 600;
    line-height: 23px;
    color: #8F8F8F;
  }
  label{
    margin: 0;
  }
}

  .__emails-container {
    background: #fff;
    height: calc(100vh - 73px);
    padding-bottom: 1rem;
  }

  .__navigators{
    overflow: hidden;
    nav{
      margin-left: 2%;
      margin-top: 0.5rem;
    }
  }

  .__wrapper{

      display: flex;
      flex-direction: row;
      height: 100%;
      padding: 0 3rem;

      .__domain-container {
          width: 40%;
          padding: 2rem 5px;
          max-width: 600px;
          margin: 0 auto;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 2rem;
          border: 1px solid #E5E5E5;
          background: var(--theme-color-primary);
          
          .__domain-list{
              width: 90%;
              padding: 0 1rem;
              color: #fff;
              list-style-type: none;
              overflow-y: auto;
              height: 100%;

              &::-webkit-scrollbar-thumb {
                  background: #e9edf2;
              }
              &::-webkit-scrollbar-track {
                  background: var(--theme-color-primary);
              }
              
              .__domain{
                  padding: 15px 0;
                  font-size: 1.15rem;
                  min-height: 40px;
                  border-bottom: 1px solid #fff6;

                  &:hover{
                    background: var(--theme-color-primary-light);
                    cursor: pointer;
                  }

                  i{
                    float:right;
                    margin-right: 10px;
                  }

                  .__loader{
                    float:right;
                    margin-right: 10px;
                    width: 18.5px;
                  }
              }

              .__domain-selected{
                  padding-top: 15px;
                  font-size: 20px;
                  min-height: 40px;
                  background: var(--theme-color-primary-light);
                  border-bottom: 0;
                  margin-left: -15px;
                  margin-right: -15px;

                  &:hover{
                    cursor: pointer;
                  }

                  i{
                    float:right;
                    margin-right: 10px;
                  }
                  ul {
                    background: var(--theme-color-primary-light);
                    margin-top: 15px;
                    padding: 8px 13px;
                  }

                .__email{
                    font-size: .95rem;
                    padding: 5px 0px;
                }
              }
          }
      }

      .__email-actions {
          width: 60%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          padding: 1rem;

          .__btnCreate{
            font-size: 1.3rem;
            border-radius: 2rem;
            opacity: 1;
            padding: 1.1rem 2rem;

            &:focus-within{
              color: #fff !important;
            }
            

            img{
              vertical-align: top;
              margin-right: 0.8rem;
              margin-left: 0.8rem;
            }
          }

          .__btnList{
            margin-top: 1.2rem;
            font-size: 1.3rem;
            border-radius: 2rem;
            background: #fff;
            color:  var(--theme-color-primary);
            border: 1px  var(--theme-color-primary) solid;
            opacity: 1;
            min-width: fit-content;
            padding: 1.1rem 5rem;
          }

          .__info{
            padding-top: 0.5rem;
            color: var(--theme-color-primary);
          }

          .__btn-disabled{
            cursor:not-allowed;
            opacity: 0.5;
          }

      }
  }

  .no_domain_info{
    padding-top: 100px;
    padding-bottom: calc(100vh - 550px);
    color: #fff;
  }
  @media screen and (max-width: 900px) {
      .__emails-container {
        height: unset;
      }

      .__wrapper {
          flex-direction: column-reverse;
          padding: 0;

          .__domain-container {
            width: 95%;
            margin-bottom: 10%;
            padding: 10px;

            .__domain-list {
                width: 100%;
                overflow-y: auto;
                max-height: 90%;
                overflow-x: hidden;
            }
          }
          .__email-actions {
              width: 100%;
              .__btnCreate {
                padding: 0.8rem 1.5rem;
                img {
                  height: 21px;
                }
              }
              .__btnList {
                padding: 0.8rem 3rem;
              }
          }
              
      }
  }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/emails-app/index.vue